<script lang="ts" setup>
import icCircleGreen from '@/assets/img/icon/check-circle-green.png';
import icCircleIcon from '@/assets/img/icon/check-circle.png';
import AppTypography from './AppTypography.vue';

const { password = '' } = defineProps<{
  password?: string;
}>();

const appConfig = useRuntimeConfig();

const hasEightCharacters = computed(() => password.length >= Number(appConfig.app.passwordCriteria.minLength));
const hasOneUppercase = computed(() => {
  const uppercaseMatches = password.match(/[A-Z]/g);
  return uppercaseMatches && uppercaseMatches.length >= Number(appConfig.app.passwordCriteria.minUppercase);
});
const hasSpecialCharacter = computed(() => {
  const specialCharMatches = password.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g);
  return specialCharMatches && specialCharMatches.length >= Number(appConfig.app.passwordCriteria.minSpecialCharacters);
});
const hasNumber = computed(() => /\d/.test(password));
</script>
<template>
  <v-sheet
    v-if="password"
    class="password-criteria d-flex flex-column"
    :class="{
      'password-criteria--eight-chars': hasEightCharacters,
      'password-criteria--one-uppercase': hasOneUppercase,
      'password-criteria--one-number': hasNumber,
    }"
  >
    <div
      class="d-flex pa-o"
      :class="{
        'password-checked': hasEightCharacters,
      }"
      data-testid="eigth-characters"
    >
      <img :src="hasEightCharacters ? icCircleGreen : icCircleIcon" width="28px" height="28px" />
      <AppTypography type="footnote-1" class="font-footnote ml-1 pa-1">
        at least {{ appConfig.app.passwordCriteria.minLength }} characters
      </AppTypography>
    </div>
    <div
      class="d-flex pa-o mt-1"
      :class="{
        'password-checked': hasOneUppercase,
      }"
      data-testid="one-uppercase"
    >
      <img :src="hasOneUppercase ? icCircleGreen : icCircleIcon" width="28px" height="28px" />
      <AppTypography type="footnote-1" class="font-footnote ml-1 pa-1">
        at least {{ appConfig.app.passwordCriteria.minUppercase }} uppercase letter
      </AppTypography>
    </div>
    <div
      class="d-flex pa-o mt-1"
      :class="{
        'password-checked': hasSpecialCharacter,
      }"
      data-testid="one-special-character"
    >
      <img :src="hasSpecialCharacter ? icCircleGreen : icCircleIcon" width="28px" height="28px" />
      <AppTypography type="footnote-1" class="font-footnote ml-1 pa-1">
        at least {{ appConfig.app.passwordCriteria.minSpecialCharacters }} special character
      </AppTypography>
    </div>
    <div
      class="d-flex pa-o mt-1"
      :class="{
        'password-checked': hasNumber,
      }"
      data-testid="one-number"
    >
      <img :src="hasNumber ? icCircleGreen : icCircleIcon" width="28px" height="28px" />
      <AppTypography type="footnote-1" class="font-footnote ml-1 pa-1">
        at least {{ appConfig.app.passwordCriteria.minNumbers }} number
      </AppTypography>
    </div>
  </v-sheet>
</template>
<style lang="scss" scoped>
.password-criteria {
  .password-checked {
    color: #05704e;
  }
}
</style>
